export const NAME = "core-access";

export const accesses = {
    admin: "admin",
    business: "business",
    user: "user",
};
